import { memo } from 'react';

import { ArrowRightOutlined } from '@ant-design/icons';
import moment from 'moment';
import { styled } from 'styled-components';

import CustomerImg from './CustomerImg';

const CardDivStyle = styled.div`
  .wrap {
    transition: all 0.2s linear;
  }
  .arrow {
    transition: all 0.5s linear;
  }
  .wrap:hover {
    transform: translate3d(0, -5px, 0);
    .name {
      color: #0093e6;
    }
    .arrow {
      transform: translate3d(0, 0, 0);
    }
  }
`;

const StyledHoverAColor = styled.div`
  a:hover {
    color: #0093e6;
  }
`;

const defaultImage = '//static.szlcsc.com/ecp/assets/web/page/www/brand/images/brand-big-logo.png';

const NewestBrandInfo = (props) => {
  const { resourceData } = props;

  const { brandIndexInformationData, isLgScreen } = props;
  const { informationList, introList } = brandIndexInformationData;

  const firstIntro = Array.isArray(introList) && introList.length > 0 ? introList[0] : null;
  const restIntroList =
    Array.isArray(introList) && introList.length > 1 ? (isLgScreen ? introList.slice(1) : introList.slice(1, 3)) : [];

  const firstInformation = Array.isArray(informationList) && informationList.length > 0 ? informationList[0] : null;
  const restInformationList =
    Array.isArray(informationList) && informationList.length > 1 ? informationList.slice(1) : [];

  return (
    <StyledHoverAColor>
      <div className={`mb-[30px] mt-[30px] flex _lg:w-[1552px]  w-[1200px] m-auto`}>
        <div className={'flex-1 bg-white rounded-[20px] h-[380px] mr-[10px] p-[20px]'} data-spm="bl">
          <div className={'text-[18px] font-bold text-[#000000] mb-[18px]'}>最新入驻</div>
          <div className={'flex mb-[28px]'}>
            <a
              href={`${resourceData?.projectConfigVO?.lcscListUrl}/brand/${firstIntro?.brandId}.html`}
              target="_blank"
              data-spm={1}
            >
              <CustomerImg
                src={firstIntro?.logoURL || defaultImage}
                errorimg={defaultImage}
                title={firstIntro?.brandName}
                alt={firstIntro?.brandName}
                textvalue={firstIntro?.brandName}
                className={'w-[220px] h-[115px] rounded-[10px]'}
              />
            </a>
            <div className={`flex-1 _lg:ml-[20px]  ml-[15px] mt-[8px]`}>
              <div className={`truncate _lg:w-[472px] w-[305px]`}>
                <a
                  data-spm={1}
                  className={'text-[16px] font-bold text-[#444444] leading-[21px]'}
                  title={firstIntro?.brandName}
                  href={`${resourceData?.projectConfigVO?.lcscListUrl}/brand/${firstIntro?.brandId}.html`}
                  target="_blank"
                >
                  {firstIntro?.brandName}
                </a>
              </div>
              <a
                href={`${resourceData?.projectConfigVO?.lcscListUrl}/brand/${firstIntro?.brandId}.html`}
                className={'cursor-default'}
                target="_blank"
                data-spm={1}
              >
                <p
                  className={'line-clamp-3 text-[14px]  text-[#666666] mt-[8px] leading-[24px]'}
                  dangerouslySetInnerHTML={{
                    __html: firstIntro?.intro,
                  }}
                ></p>
              </a>
            </div>
          </div>
          <div className={'flex'}>
            {restIntroList.map((item, index) => {
              return (
                <CardDivStyle key={item?.brandId}>
                  <div
                    className={`_lg:w-[228px] w-[263px] h-[145px] rounded-[8px] ${index !== restIntroList.length - 1 ? 'mr-[20px]' : ''}
                   bg-[#F6F6F6] pl-[15px] pr-[15px] pt-[17px] pb-[17px] hover:bg-[#E8F5FC] cursor-pointer wrap`}
                  >
                    <a
                      data-spm={index + 1 + 1}
                      href={`${resourceData?.projectConfigVO.lcscListUrl}/brand/${item?.brandId}.html`}
                      target="_blank"
                    >
                      <div className={'flex mb-[6px] items-center'}>
                        {/* <CustomerImg
                          src={item?.logoURL || defaultLogoImage}
                          errorimg={defaultLogoImage}
                          title={item?.brandName}
                          alt={item?.brandName}
                          className={'w-[40px] h-[40px] rounded-[40px]'}
                        /> */}
                        <div className={'text-[14px] text-[#444444] name truncate'} title={item?.brandName}>
                          {item?.brandName}
                        </div>
                      </div>
                      <p
                        className={'line-clamp-3 text-[14px]  text-[#666666] mb-[6px] leading-[24px]'}
                        dangerouslySetInnerHTML={{
                          __html: item?.intro,
                        }}
                      ></p>
                      <div className={'text-right arrow translate-x-[-10px]'}>
                        <ArrowRightOutlined className={'name'} />
                      </div>
                    </a>
                  </div>
                </CardDivStyle>
              );
            })}
          </div>
        </div>

        <div className={'flex-1  bg-white rounded-[20px] h-[380px] ml-[10px] p-[20px]'} data-spm="bn">
          <div className={'text-[18px] font-bold text-[#000000] mb-[18px]'}>品牌资讯</div>
          <div className={'flex mb-[18px]'}>
            <a
              href={`${resourceData?.projectConfigVO.lcscWwwUrl}/info/${firstInformation?.informationId}.html`}
              target="_blank"
              data-spm={1}
            >
              <CustomerImg
                src={firstInformation?.titleImage || defaultImage}
                errorimg={defaultImage}
                title={firstInformation?.title}
                alt={firstInformation?.title}
                textvalue={'品牌资讯'}
                className={'w-[220px] h-[115px] rounded-[10px]'}
              />
            </a>
            <div className={`flex-1 _lg:ml-[20px]  ml-[15px] mt-[8px]`}>
              <div className={`truncate _lg:w-[472px] w-[305px]`}>
                <a
                  className={'text-[16px] font-bold text-[#444444] leading-[21px]'}
                  title={firstInformation?.title}
                  href={`${resourceData?.projectConfigVO.lcscWwwUrl}/info/${firstInformation?.informationId}.html`}
                  target="_blank"
                  data-spm={1}
                >
                  {firstInformation?.title || '-'}
                </a>
              </div>
              <a
                href={`${resourceData?.projectConfigVO.lcscWwwUrl}/info/${firstInformation?.informationId}.html`}
                target="_blank"
                className={'cursor-default'}
                data-spm={1}
              >
                <p
                  className={'line-clamp-3 text-[14px]  text-[#666666] mt-[8px] leading-[24px]'}
                  dangerouslySetInnerHTML={{
                    __html: firstInformation?.intro,
                  }}
                ></p>
              </a>
            </div>
          </div>
          {restInformationList.map((item, index) => {
            return (
              <div className={'flex justify-between text-[14px] mb-[15px] leading-[19px]'} key={item?.informationId}>
                <div className={'flex  text-[#000000]'}>
                  <div className={`${index < 3 ? 'text-[#F3543D]' : 'text-[#56657F]'}  text-[16px] mr-[12px]`}>
                    {index + 1}
                  </div>
                  <div
                    className={`${index < 3 ? 'text-[#000000]' : 'text-[#666666]'} flex-1 _lg:max-w-[640px] max-w-[449px] truncate`}
                  >
                    <a
                      data-spm={index + 1 + 1}
                      href={`${resourceData?.projectConfigVO.lcscWwwUrl}/info/${item?.informationId}.html`}
                      target="_blank"
                    >
                      {item?.title}
                    </a>
                  </div>
                </div>
                <div className={'w-[56px] text-right text-[#D9D9D9]'}>{moment(item?.publishTime).format('MM-DD')}</div>
              </div>
            );
          })}
        </div>
      </div>
    </StyledHoverAColor>
  );
};

export default memo(NewestBrandInfo);
